
import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { Popover } from 'element-ui';

/* eslint-disable dot-notation */
/* eslint-disable global-require */
@Component({
  components: {
    Popover,
  },
})
export default class AssetBoxView extends Vue {
  @Prop({
    required: true,
  }) data!: { name: string, md5: string, coverData: any, assetData: any };

  @Prop({
    required: true,
  }) type!: string;

  @Prop({
    default: false,
  }) checked!: boolean;

  @Prop({
    default: false,
  }) isScript!: boolean;

  @Prop({
    default: false,
  }) notScript!: boolean;

  @Prop({
    default: '',
  }) id!: string;

  @Prop({
    default: false,
  }) edit!: boolean;

  public $refs!: {
    audio: HTMLAudioElement,
  }

  private cover: any = '';

  private imgUrls: { [key: string]: string } = {
    multiUrl: require('../icons/faxian.png'),
    playUrl: require('../icons/play.png'),
    pauseUrl: require('../icons/pause.png'),
    unloveUrl: require('../icons/unlove.png'),
    loveUrl: require('../icons/love.png'),
    loveImgUrl: require('../icons/loveImg.png'),
  };

  private controlImg: string = this.imgUrls['multiUrl'];

  private timer: any = null;

  private soundUrl: string = '';

  get CompStyle() {
    switch (this.type) {
      case 'sounds': return { width: '80px', height: '80px' };
      case 'sprites': return { height: '100px', width: '100%' };
      default: return {};
    }
  }

  mounted() {
    if (typeof this.data.coverData === 'string') {
      this.cover = this.data.coverData;
      if (this.type === 'sounds') this.controlImg = this.imgUrls['playUrl'];
      return;
    }
    if (this.type !== 'sounds') {
      this.data.coverData.then((res: any) => { this.cover = res; });
    } else {
      this.cover = this.data.coverData;
      this.controlImg = this.imgUrls['playUrl'];
    }
  }

  /**
   * @author Terry
   * @description 处理声音播放或者图片轮播
   * @params { Boolean } true 开始 false 关闭
   */
  handleControl(flag: boolean) {
    /* eslint-disable no-return-assign */
    if (this.type === 'sprites') {
      if (this.timer) clearInterval(this.timer);
      if (flag) {
        let index: number = 0;
        this.timer = setInterval(() => {
          if (index === this.data.assetData.length) index = 0;
          /* eslint-disable no-plusplus */
          if (typeof this.data.assetData[index] === 'string') this.cover = this.data.assetData[index];
          else this.data.assetData[index].then((res: any) => this.cover = res);
          index += 1;
        }, 240);
      } else {
        /* eslint-disable prefer-destructuring */
        /* eslint-disable no-lonely-if */
        if (typeof this.data.assetData[0] === 'string') this.cover = this.data.assetData[0];
        else this.data.assetData[0].then((res: any) => this.cover = res);
      }
    }
    if (this.type === 'sounds') {
      if (flag) {
        if (typeof this.data.assetData === 'string') this.soundUrl = this.data.assetData;
        else this.data.assetData.then((res: any) => (this.soundUrl = res));
        this.controlImg = this.imgUrls['pauseUrl'];
        this.$refs.audio.autoplay = true;
      } else {
        this.controlImg = this.imgUrls['playUrl'];
        this.soundUrl = '';
        this.$refs.audio.autoplay = false;
      }
    }
  }

  /**
   * @author Terry
   * @description 处理收藏
   */
  handleLove() {
    this.$emit('handleCheck', this.data.md5);
  }

  destoryed() {
    clearInterval(this.timer);
  }
}
